import React, { useEffect, useRef, useState } from "react";
import {
  Content,
  Text,
  TitleContainer,
  DetailsData,
  DetailsDataValue,
  DetailsContainer,
  InvoiceDiv,
  Select,
  Option,
  DropDownContainer,
  GalleryRow,
  StyledAttachment,
  Button,
  SelectForbidden,
  ItemDetailsContainer,
  VoucherCodeContainer,
  StyledDetailsDataValue,
  LoaderDiv,
  GalleryIcon,
  GalleryColumn,
  GalleryText,
  Row,
  ItemImage,
  ButtonApprove,
  ButtonsContainer,
  TextAreaLabel,
  TextAreaContainer,
  TextArea,
  TextAreaText,
  ApprovedText,
  StyledDownload,
} from "./MarketplaceOrderDetailsPage.styles";

import ContentHeader from "../utils/ContentHeader";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import {
  acceptDesign,
  acceptPackageDesign,
  getOrder,
  rejectDesign,
  rejectPackageDesign,
  updateOrderState,
} from "../../../store/slices/marketplace/asyncThunks";
import { ReactComponent as PdfIcon } from "../../../assets/icons/pdf.svg";

import {
  ButtonBackContainer,
  DetailsDataWrapper,
} from "../GiftOrderDetailsPage/GiftOrderDetailsPage.styles";
import { ButtonBack } from "../SendGiftsPage/SendGiftsPage.styles";
import {
  marketplaceOrderLoader,
  ordersData,
  orderDataState,
} from "../../../store/slices/marketplace/marketplaceSlice";
import {
  MAP_LIBRARIES,
  businessUserRoleAction,
  getCurrencySymbol,
  googlePlacesKey,
  marketplaceOrderStates,
  marketplacePaymentStatus,
} from "../../../utils/constants";
import { checkPermission, priceFormatter } from "../../../utils/utils";
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import MiniLoader from "../../../components/MiniLoader/MiniLoader";
import { ReactComponent as CopyIcon } from "../../../assets/icons/copy.svg";
import GalleryModal from "../../../components/Modal/GalleryModal";
import ApproveModal from "../../../components/Modal/ApproveModal";
import AppLoader from "../../../components/AppLoader";
import openToast from "../../../utils/toast";

const MarketplaceOrderDetailsPage = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const params = useParams();
  const id = params.orderId;
  const order = useSelector(ordersData);
  const orderStateRedux = useSelector(orderDataState);
  const orderLoading = useSelector(marketplaceOrderLoader);
  const businessUser = useSelector((state) => state.businessUser);
  const mapRef = useRef(null);
  const [openGallery, setOpenGallery] = useState(false);
  const [clickedImage, setClickedImage] = useState("");
  const [images, setImages] = useState([]);
  const [openModalApprove, setOpenModalApprove] = useState({
    open: false,
    text: "",
    title: "",
  });

  const [clickGalleryTracker, setClickGalleryTracker] = useState({});
  const [customersNotes, setCustomersNotes] = useState({});
  const [customersPackageNotes, setCustomersPackageNotes] = useState({});
  const [acceptedDesign, setAcceptedDesign] = useState({});
  const [declinedDesign, setDeclinedDesign] = useState({});
  const [acceptLoader, setAcceptLoader] = useState(false);
  const [rejectLoader, setRejectLoader] = useState(false);
  const [acceptedPackageDesign, setAcceptedPackageDesign] = useState({});
  const [declinedPackageDesign, setDeclinedPackageDesign] = useState({});
  const [acceptPackageLoader, setAcceptPackageLoader] = useState(false);
  const [rejectPackageLoader, setRejectPackageLoader] = useState(false);

  const toastId = useRef(null);
  const handleOpenGallery = ({ images, index }) => {
    setClickedImage(index);
    setImages(images);
    setOpenGallery(true);
  };

  useEffect(() => {
    dispatch(getOrder(id))
      .unwrap()
      .catch((error) => {
        openToast(toastId, "error-get-order", "error", error.message);
      });
  }, [dispatch, id]);

  if (!order) {
    return <TitleContainer>Loading...</TitleContainer>;
  }

  // eslint-disable-next-line react-hooks/rules-of-hooks
  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: googlePlacesKey,
    libraries: MAP_LIBRARIES,
  });

  const center = {
    lat: order?.location?.lat,
    lng: order?.location?.lng,
  };
  const onLoad = function callback(map) {
    mapRef.current = map;
    map.setCenter(center);
    map.setZoom(14);
  };

  const handleInvoiceMarketplaceClick = () => {
    if (order?.invoiceUrl) {
      window.open(order?.invoiceUrl, "_blank");
    }
  };

  const getItemPhoto = (subItems, marketplaceItem, item) => {
    if (
      item.marketplaceOrderItemPhotos &&
      item.marketplaceOrderItemPhotos.length &&
      !item.marketplaceOrderItemPhotos[0]?.photoUrl.includes(".pdf")
    ) {
      return item.marketplaceOrderItemPhotos[0]?.photoUrl;
    }

    if (subItems) {
      for (const i of subItems) {
        if (i.marketplacePhotos.length) {
          return i.marketplacePhotos[0]?.url;
        }
      }
    }

    if (marketplaceItem && marketplaceItem.marketplacePhotos?.length) {
      return marketplaceItem.marketplacePhotos[0].url;
    }
  };

  const handleLogoUrlClick = (urls) => {
    if (urls && urls.length > 0) {
      urls.forEach((url, index) => {
        setTimeout(() => {
          window.open(url, "_blank");
        }, index * 500);
      });
    }
  };

  const handleTracker = (id, value) => {
    setClickGalleryTracker((prev) => ({
      ...prev,
      [id]: value,
    }));
  };

  const handleAddNote = (id, event, type) => {
    const { value } = event.target;
    if (type === "package") {
      setCustomersPackageNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    } else {
      setCustomersNotes((prev) => ({
        ...prev,
        [id]: value,
      }));
    }
  };
  const renderItem = (item, index) => {
    return (
      <DetailsContainer
        key={index}
        style={{
          borderTop: "5px solid #48488888",
        }}
      >
        <ItemDetailsContainer>
          <div style={{ flexDirection: "row", display: "flex" }}>
            <DetailsData>{t("quantity")}: </DetailsData>
            <DetailsDataValue>{item.quantity}</DetailsDataValue>
          </div>
          {!!item.marketplaceSubcategoryItems.length && (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <DetailsData>
                {t(
                  `${item.marketplaceSubcategoryItems[0].marketplaceSubcategory.value}`
                )}
                :
              </DetailsData>
              <DetailsDataValue>
                {item.marketplaceSubcategoryItems[0].value}
              </DetailsDataValue>
            </div>
          )}
          {item.marketplaceItem?.price && (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <DetailsData>{t("price")}: </DetailsData>
              {!item.marketplaceSubcategoryItems[0]?.price ? (
                <DetailsDataValue>
                  {item.sampleItem || item.printedItem
                    ? `${priceFormatter(
                        item?.price,
                        true,
                        15
                      )} ${getCurrencySymbol(item.marketplaceItem?.currency)}`
                    : `${priceFormatter(
                        item.marketplaceItem?.price,
                        true,
                        15
                      )} ${getCurrencySymbol(item.marketplaceItem?.currency)}`}
                </DetailsDataValue>
              ) : (
                <DetailsDataValue>
                  {`${priceFormatter(
                    item.marketplaceSubcategoryItems[0]?.price
                  )} ${getCurrencySymbol(item.marketplaceItem?.currency)}`}
                </DetailsDataValue>
              )}
            </div>
          )}
          {item.giftCardStatus && (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <DetailsData>{t("gift-card-status")}: </DetailsData>
              <DetailsDataValue>{item.giftCardStatus}</DetailsDataValue>
            </div>
          )}
          {item.pinCode && (
            <>
              <DetailsData>{t("pin-code")}: </DetailsData>
              <DetailsDataValue>{item.pinCode} </DetailsDataValue>
              <CopyIcon
                fill="#484888"
                width={20}
                height={20}
                style={{
                  cursor: "pointer",
                  marginTop: 3,
                  marginLeft: 6,
                }}
                onClick={() => navigator.clipboard.writeText(item.pinCode)}
              />
            </>
          )}
          {item.validTo && (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <DetailsData>{t("valid-to")}: </DetailsData>
              <DetailsDataValue>{item.validTo}</DetailsDataValue>
            </div>
          )}
          {item.voucherCode && (
            <>
              <VoucherCodeContainer>
                <DetailsData>{t("voucher-code")}: </DetailsData>
                {item.voucherCode.split(",").map((code, index) => (
                  <div
                    key={index}
                    style={{
                      flexDirection: "row",
                      display: "flex",
                    }}
                  >
                    <StyledDetailsDataValue>
                      {code.trim()}
                    </StyledDetailsDataValue>
                    <CopyIcon
                      fill="#484888"
                      width={20}
                      height={20}
                      style={{
                        cursor: "pointer",
                        marginTop: 3,
                        marginLeft: 6,
                      }}
                      onClick={() => navigator.clipboard.writeText(code.trim())}
                    />
                  </div>
                ))}
              </VoucherCodeContainer>
            </>
          )}
          {item.logoUrl && (
            <div style={{ flexDirection: "row", display: "flex" }}>
              <DetailsData>{t("logo")}: </DetailsData>
              <StyledAttachment
                className="attachment-icon"
                onClick={() => handleLogoUrlClick([item.logoUrl])}
              />
            </div>
          )}

          {item.marketplaceOrderItemPhotos.some((photo) =>
            photo.photoUrl.includes(".pdf")
          )
            ? !!item.marketplaceOrderItemPhotos.length && (
                <Row>
                  <DetailsData>{t("pdf-file")}</DetailsData>
                  <StyledDownload
                    className="file-download"
                    onClick={() => {
                      handleTracker(item?.id, true);

                      const pdfUrls = item.marketplaceOrderItemPhotos
                        .filter(
                          (photo) =>
                            photo.createdBy === "designer" &&
                            photo.photoUrl.includes(".pdf")
                        )
                        .map((photo) => photo.photoUrl);

                      handleLogoUrlClick(pdfUrls);
                    }}
                  />
                </Row>
              )
            : !!item.marketplaceOrderItemPhotos.length && (
                <Row>
                  <DetailsData>{t("design-files")}</DetailsData>
                  <StyledDownload
                    className="file-download"
                    onClick={() => {
                      handleTracker(item?.id, true);

                      const urls = item.marketplaceOrderItemPhotos
                        .filter((photo) => photo.createdBy === "designer")
                        .map((photo) => photo.photoUrl);

                      handleLogoUrlClick(urls);
                    }}
                  />
                </Row>
              )}

          {!!item?.marketplaceOrderItemPhotos?.filter(
            (photo) =>
              photo.createdBy === "designer" && photo.state === "pending"
          ).length &&
            !acceptedDesign[item.id] &&
            !declinedDesign[item.id] && (
              <ButtonsContainer>
                {acceptLoader ? (
                  <ButtonApprove>
                    <AppLoader size={24} light />
                  </ButtonApprove>
                ) : (
                  <ButtonApprove
                    disabled={acceptLoader || rejectLoader}
                    onClick={() => {
                      if (
                        !clickGalleryTracker[item.id] &&
                        item.marketplaceOrderItemPhotos.length > 1
                      ) {
                        setOpenModalApprove({
                          open: true,
                          text: "please-review-the-files",
                          title: "attention",
                        });
                      } else {
                        setAcceptLoader(true);
                        dispatch(acceptDesign(item.id))
                          .unwrap()
                          .then((response) => {
                            setAcceptLoader(false);
                            setAcceptedDesign((prev) => ({
                              ...prev,
                              [item.id]: true,
                            }));

                            if (response.data.isLastOne) {
                              setOpenModalApprove({
                                open: true,
                                text: "we-will-start-production-right-away",
                                title: "congratulations",
                              });
                            } else {
                              setOpenModalApprove({
                                open: true,
                                text: "we-will-start-production-on-the-approve",
                                title: "good-progress",
                              });
                            }
                          })
                          .catch((err) =>
                            openToast(
                              toastId,
                              "error-accept-design",
                              "error",
                              err.message
                            )
                          );
                      }
                    }}
                  >
                    {t("approve")}
                  </ButtonApprove>
                )}
                {rejectLoader ? (
                  <ButtonApprove $reject>
                    <AppLoader size={24} light />
                  </ButtonApprove>
                ) : (
                  <ButtonApprove
                    disabled={acceptLoader || rejectLoader}
                    $reject
                    onClick={() => {
                      if (!clickGalleryTracker[item.id]) {
                        setOpenModalApprove({
                          open: true,
                          text: "please-review-the-files",
                          title: "attention",
                        });
                      }
                      if (!customersNotes[item.id]) {
                        setOpenModalApprove({
                          open: true,
                          text: "please-add-your-notes",
                          title: "attention",
                        });
                      }
                      if (
                        customersNotes[item?.id] &&
                        clickGalleryTracker[item?.id]
                      ) {
                        setRejectLoader(true);

                        dispatch(
                          rejectDesign({
                            id: item.id,
                            note: customersNotes[item.id],
                          })
                        )
                          .unwrap()
                          .then(() => {
                            setRejectLoader(false);
                            setDeclinedDesign((prev) => ({
                              ...prev,
                              [item.id]: true,
                            }));
                            setOpenModalApprove({
                              open: true,
                              text: "we-will-update-the-designs",
                              title: "thanks-for-feedback",
                            });
                          })
                          .catch((err) =>
                            openToast(
                              toastId,
                              "error-reject",
                              "error",
                              err.message
                            )
                          );
                      }
                    }}
                  >
                    {t("reject")}
                  </ButtonApprove>
                )}
              </ButtonsContainer>
            )}

          {!!item?.marketplaceOrderItemPhotos?.filter(
            (photo) => photo.state === "accepted"
          ).length && <ApprovedText>{t("approved2")}</ApprovedText>}

          {!!item?.marketplaceOrderItemPhotos?.filter(
            (photo) => photo.state === "declined"
          ).length && <ApprovedText $reject>{t("declined2")}</ApprovedText>}

          {acceptedDesign[item.id] && (
            <ApprovedText>{t("approved2")}</ApprovedText>
          )}

          {declinedDesign[item.id] && (
            <ApprovedText $reject>{t("declined2")}</ApprovedText>
          )}
        </ItemDetailsContainer>

        {!!item?.marketplaceOrderItemPhotos?.filter(
          (photo) => photo.createdBy === "designer" && photo.state === "pending"
        ).length ? (
          <TextAreaContainer>
            <TextAreaLabel>{t("customers-notes")}:</TextAreaLabel>
            <TextArea
              disabled={declinedDesign[item.id] || acceptedDesign[item.id]}
              onChange={(event) => handleAddNote(item.id, event, "product")}
              value={customersNotes[item.id] || ""}
            />
          </TextAreaContainer>
        ) : (
          <TextAreaContainer>
            <TextAreaLabel>{t("customers-notes")}:</TextAreaLabel>
            <TextAreaText>{item?.customerNote}</TextAreaText>
          </TextAreaContainer>
        )}

        <TextAreaContainer>
          <TextAreaLabel>{t("designers-notes")}:</TextAreaLabel>
          <TextAreaText>{item?.designerNote}</TextAreaText>
        </TextAreaContainer>

        <GalleryRow>
          {item.marketplaceOrderItemPhotos &&
            item.marketplaceOrderItemPhotos.length > 1 && (
              <GalleryColumn>
                <GalleryIcon
                  onClick={() => {
                    if (
                      item.marketplaceOrderItemPhotos &&
                      item.marketplaceOrderItemPhotos.length
                    ) {
                      handleOpenGallery({
                        images: item.marketplaceOrderItemPhotos,
                        index: 0,
                      });
                    }
                  }}
                />
                <GalleryText>{t("view-designs")}</GalleryText>
              </GalleryColumn>
            )}

          {item.marketplaceOrderItemPhotos &&
          item.marketplaceOrderItemPhotos.length ? (
            item.marketplaceOrderItemPhotos[0].photoUrl.includes("pdf") ? (
              <PdfIcon width={40} height={40}></PdfIcon>
            ) : (
              <img
                src={
                  item.marketplaceOrderItemPhotos &&
                  item.marketplaceOrderItemPhotos.length
                    ? item.marketplaceOrderItemPhotos[0].photoUrl
                    : item.marketplaceItem?.marketplacePhotos[0]?.url
                }
                className="img"
                style={{
                  display: "flex",
                  height: 250,
                  maxWidth: 750,
                }}
                alt="img"
              />
            )
          ) : (
            <img
              src={getItemPhoto(
                item.marketplaceSubcategoryItems,
                item.marketplaceItem,
                item
              )}
              className="img"
              style={{
                display: "flex",
                height: 250,
                maxWidth: 750,
              }}
              alt="img"
            />
          )}
        </GalleryRow>
      </DetailsContainer>
    );
  };

  return (
    <>
      <ContentHeader title={t("order-details")} showTitle={true} />
      {!orderLoading ? (
        <>
          <TitleContainer>
            <Text>
              {t("order-#")} {order?.id}
            </Text>
          </TitleContainer>
          {checkPermission(
            businessUser,
            businessUserRoleAction.put_marketplace_orders
          ) ? (
            <>
              <DropDownContainer style={{ marginTop: 18 }}>
                <DetailsData> {t("order-state")}:</DetailsData>
                <Select
                  id="userDropdown"
                  onChange={(event) => {
                    const selectedStateId = parseInt(event.target.value);
                    const selectedState = marketplaceOrderStates.find(
                      (state) => state.id === selectedStateId
                    );
                    const selectedStateValue = selectedState?.value;
                    dispatch(
                      updateOrderState({ id, state: selectedStateValue })
                    );
                  }}
                >
                  {marketplaceOrderStates.map((state) => (
                    <Option
                      key={state.id}
                      value={state.id}
                      selected={orderStateRedux === state.value}
                    >
                      {t(state.value)}
                    </Option>
                  ))}
                </Select>
              </DropDownContainer>
              <DropDownContainer style={{ marginBottom: 10 }}>
                <DetailsData>{t("payment-status")}:</DetailsData>
                {order.paymentStatus === "pending" ? (
                  <Select
                    id="userDropdown"
                    onChange={(event) => {
                      const selectedStatusId = parseInt(event.target.value);
                      const selectedPaymentStatus =
                        marketplacePaymentStatus.find(
                          (status) => status.id === selectedStatusId
                        );
                      const selectedStatusValue = selectedPaymentStatus?.value;
                      dispatch(
                        updateOrderState({
                          id,
                          paymentStatus: selectedStatusValue,
                        })
                      );
                    }}
                  >
                    {marketplacePaymentStatus.map((status) => (
                      <Option
                        key={status.id}
                        value={status.id}
                        selected={order.paymentStatus === status.value}
                      >
                        {t(status.value)}
                      </Option>
                    ))}
                  </Select>
                ) : (
                  <SelectForbidden>{t(order.paymentStatus)}</SelectForbidden>
                )}
              </DropDownContainer>
            </>
          ) : (
            <>
              <DetailsContainer style={{ marginTop: 18 }}>
                <DetailsData>{t("order-state")}: </DetailsData>
                <DetailsDataValue>{t(order.state)}</DetailsDataValue>
              </DetailsContainer>
              <DetailsContainer>
                <DetailsData>{t("payment-status")}: </DetailsData>
                <DetailsDataValue>{t(order.paymentStatus)}</DetailsDataValue>
              </DetailsContainer>
            </>
          )}
          <Content>
            {order?.deliveryAddress?.floorNumber ? (
              <DetailsContainer>
                <DetailsData>{t("floor")}: </DetailsData>
                <DetailsDataValue>
                  {order.deliveryAddress?.floorNumber}
                </DetailsDataValue>
              </DetailsContainer>
            ) : null}
            {order?.deliveryAddress?.nearestLandmark ? (
              <DetailsContainer>
                <DetailsData>{t("nearest-landmark")}: </DetailsData>
                <DetailsDataValue>
                  {order?.deliveryAddress?.nearestLandmark}
                </DetailsDataValue>
              </DetailsContainer>
            ) : null}
            <DetailsContainer>
              <DetailsData>{t("total-price")}: </DetailsData>
              <DetailsDataValue>
                {`${priceFormatter(order?.totalPrice)} ${getCurrencySymbol(
                  order?.currency
                )}`}
              </DetailsDataValue>
            </DetailsContainer>

            {order.notes !== null && (
              <DetailsContainer>
                <DetailsData>{t("notes")}: </DetailsData>
                <DetailsDataValue>{order.notes}</DetailsDataValue>
              </DetailsContainer>
            )}
            {order?.location?.name && (
              <>
                <DetailsContainer>
                  <DetailsData>{t("date-of-delivery")}:</DetailsData>
                  <DetailsDataValue>{order?.dateOfDelivery}</DetailsDataValue>
                </DetailsContainer>
                <DetailsContainer>
                  <DetailsData>{t("delivery-location")}: </DetailsData>
                  <DetailsDataWrapper
                    style={{
                      width: "100%",
                      maxWidth: "500px",
                      maxHeight: "380px",
                      flexDirection: "column",
                      display: "flex",
                    }}
                  >
                    <DetailsDataValue
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {t("full-name")}: {order.fullName}
                    </DetailsDataValue>
                    <DetailsDataValue
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {t("phone-number")}: {order.mobilePhone}
                    </DetailsDataValue>
                    <DetailsDataValue
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {t("address")}: {order?.location?.name}
                    </DetailsDataValue>
                    <DetailsDataValue
                      style={{
                        textAlign: "right",
                      }}
                    >
                      {order.addressDetails && (
                        <>
                          {t("address-details")}: {order.addressDetails}
                        </>
                      )}
                    </DetailsDataValue>
                    {isLoaded ? (
                      <GoogleMap
                        mapContainerStyle={{
                          border: "1px solid #d1d1d4",
                          width: "100%",
                          maxWidth: "500px",
                          height: "330px",
                          marginTop: "10px",
                        }}
                        onLoad={(map) => {
                          mapRef.current = map;
                          onLoad(map);
                        }}
                        zoom={14}
                        center={center}
                      >
                        <Marker position={center} />
                      </GoogleMap>
                    ) : (
                      <MiniLoader />
                    )}
                  </DetailsDataWrapper>
                </DetailsContainer>
              </>
            )}
            <DetailsContainer>
              <DetailsData>{t("invoice")}: </DetailsData>
              <InvoiceDiv>
                {order.paymentStatus === "paid" && order.invoiceUrl && (
                  <Button onClick={handleInvoiceMarketplaceClick}>
                    {t("download-invoice")}
                  </Button>
                )}
              </InvoiceDiv>
            </DetailsContainer>
            {order.marketplaceOrderPackageId &&
              order.marketplaceOrderPackage && (
                <DetailsContainer
                  style={{
                    flexDirection: "column",
                    display: "flex",
                    justifyContent: "flex-start",
                  }}
                >
                  <DetailsData>{t("package-details")}:</DetailsData>
                  <DetailsContainer
                    style={{
                      borderTop: "5px solid #48488888",
                    }}
                  >
                    <ItemDetailsContainer>
                      <Row>
                        <DetailsData>{t("name")}: </DetailsData>
                        <DetailsDataValue>
                          {t(`${order.marketplaceOrderPackage?.name}`)}
                        </DetailsDataValue>
                      </Row>
                      <Row>
                        <DetailsData>{t("price")}: </DetailsData>
                        <DetailsDataValue>
                          {order.packagePrice + " SR"}
                        </DetailsDataValue>
                      </Row>
                      {order.packageColor && (
                        <Row>
                          <DetailsData>{t(`color`)}:</DetailsData>
                          <DetailsDataValue>
                            {order.packageColor}
                          </DetailsDataValue>
                        </Row>
                      )}

                      {order.packageLogoUrl && (
                        <Row>
                          <DetailsData>{t("logo")}: </DetailsData>
                          <StyledAttachment
                            className="attachment-icon"
                            onClick={() =>
                              handleLogoUrlClick([order.packageLogoUrl])
                            }
                          />
                        </Row>
                      )}

                      {order.packageDesignUrl && (
                        <Row>
                          {order?.packageDesignUrl.includes(".pdf") ? (
                            <DetailsData>{t("pdf-file")}</DetailsData>
                          ) : (
                            <DetailsData>{t("design-files")}</DetailsData>
                          )}
                          <StyledDownload
                            className="file-download"
                            onClick={() => {
                              handleTracker(order.id, true);
                              handleLogoUrlClick([order.packageDesignUrl]);
                            }}
                          />
                        </Row>
                      )}

                      {order?.packageDesignState === "pending" &&
                        !acceptedPackageDesign[order?.id] &&
                        !declinedPackageDesign[order?.id] && (
                          <ButtonsContainer>
                            {acceptPackageLoader ? (
                              <ButtonApprove>
                                <AppLoader size={24} light />
                              </ButtonApprove>
                            ) : (
                              <ButtonApprove
                                disabled={
                                  acceptPackageLoader || rejectPackageLoader
                                }
                                onClick={() => {
                                  setAcceptPackageLoader(true);
                                  dispatch(acceptPackageDesign(order?.id))
                                    .unwrap()
                                    .then((response) => {
                                      setAcceptPackageLoader(false);
                                      setAcceptedPackageDesign((prev) => ({
                                        ...prev,
                                        [order?.id]: true,
                                      }));

                                      if (response.data.isLastOne) {
                                        setOpenModalApprove({
                                          open: true,
                                          text: "we-will-start-production-right-away",
                                          title: "congratulations",
                                        });
                                      } else {
                                        setOpenModalApprove({
                                          open: true,
                                          text: "we-will-start-production-on-the-approve",
                                          title: "good-progress",
                                        });
                                      }
                                    })
                                    .catch((err) =>
                                      openToast(
                                        toastId,
                                        "error-accept-package-design",
                                        "error",
                                        err.message
                                      )
                                    );
                                }}
                              >
                                {t("approve")}
                              </ButtonApprove>
                            )}
                            {rejectPackageLoader ? (
                              <ButtonApprove $reject>
                                <AppLoader size={24} light />
                              </ButtonApprove>
                            ) : (
                              <ButtonApprove
                                disabled={
                                  acceptPackageLoader || rejectPackageLoader
                                }
                                $reject
                                onClick={() => {
                                  if (!customersPackageNotes[order?.id]) {
                                    setOpenModalApprove({
                                      open: true,
                                      text: "please-add-your-notes",
                                      title: "attention",
                                    });
                                  }
                                  if (!clickGalleryTracker[order?.id]) {
                                    setOpenModalApprove({
                                      open: true,
                                      text: "please-review-the-files",
                                      title: "attention",
                                    });
                                  }
                                  if (
                                    customersPackageNotes[order?.id] &&
                                    clickGalleryTracker[order?.id]
                                  ) {
                                    setRejectPackageLoader(true);

                                    dispatch(
                                      rejectPackageDesign({
                                        id: order?.id,
                                        note: customersPackageNotes[order?.id],
                                      })
                                    )
                                      .unwrap()
                                      .then(() => {
                                        setRejectPackageLoader(false);
                                        setDeclinedPackageDesign((prev) => ({
                                          ...prev,
                                          [order?.id]: true,
                                        }));
                                        setOpenModalApprove({
                                          open: true,
                                          text: "we-will-update-the-designs",
                                          title: "thanks-for-feedback",
                                        });
                                      })
                                      .catch((err) =>
                                        openToast(
                                          toastId,
                                          "error-reject-package-design",
                                          "error",
                                          err.message
                                        )
                                      );
                                  }
                                }}
                              >
                                {t("reject")}
                              </ButtonApprove>
                            )}
                          </ButtonsContainer>
                        )}

                      {order?.packageDesignState === "accepted" && (
                        <ApprovedText>{t("approved2")}</ApprovedText>
                      )}

                      {order?.packageDesignState === "declined" && (
                        <ApprovedText $reject>{t("declined2")}</ApprovedText>
                      )}

                      {acceptedPackageDesign[order?.id] && (
                        <ApprovedText>{t("approved2")}</ApprovedText>
                      )}

                      {declinedPackageDesign[order?.id] && (
                        <ApprovedText $reject>{t("declined2")}</ApprovedText>
                      )}
                    </ItemDetailsContainer>

                    {order?.packageDesignState === "pending" ? (
                      <TextAreaContainer>
                        <TextAreaLabel>{t("customers-notes")}:</TextAreaLabel>
                        <TextArea
                          disabled={
                            declinedPackageDesign[order?.id] ||
                            acceptedPackageDesign[order?.id]
                          }
                          onChange={(event) =>
                            handleAddNote(order?.id, event, "package")
                          }
                          value={customersPackageNotes[order?.id] || ""}
                        />
                      </TextAreaContainer>
                    ) : (
                      <TextAreaContainer>
                        <TextAreaLabel>{t("customers-notes")}:</TextAreaLabel>
                        <TextAreaText>
                          {order?.packageCustomerNote}
                        </TextAreaText>
                      </TextAreaContainer>
                    )}

                    <TextAreaContainer>
                      <TextAreaLabel>{t("designers-notes")}:</TextAreaLabel>
                      <TextAreaText>{order?.packageDesignerNote}</TextAreaText>
                    </TextAreaContainer>

                    {order.marketplaceOrderPackage &&
                      order.marketplaceOrderPackage.photoUrl &&
                      (order.marketplaceOrderPackage.photoUrl.includes(
                        ".pdf"
                      ) ? (
                        <PdfIcon />
                      ) : (
                        <ItemImage
                          src={
                            order.packageDesignUrl ||
                            order.marketplaceOrderPackage.photoUrl
                          }
                          alt="img"
                        />
                      ))}
                  </DetailsContainer>
                </DetailsContainer>
              )}
            {order?.packageItems?.length > 0 && (
              <DetailsContainer
                style={{
                  flexDirection: "column",
                  display: "flex",
                  justifyContent: "flex-start",
                }}
              >
                <DetailsData>{t("package-details")}:</DetailsData>
                {order?.packageItems.map((item, index) => {
                  return renderItem(item, index);
                })}
              </DetailsContainer>
            )}
            <DetailsContainer
              style={{
                flexDirection: "column",
                display: "flex",
                justifyContent: "flex-start",
              }}
            >
              <DetailsData>{t("item-details")}:</DetailsData>
              {order?.marketplaceOrderItems.map((item, index) => {
                return renderItem(item, index);
              })}
            </DetailsContainer>

            <ButtonBackContainer>
              <ButtonBack onClick={() => navigation(-1)}>
                {t("back")}
              </ButtonBack>
            </ButtonBackContainer>
          </Content>
        </>
      ) : (
        <LoaderDiv>
          <MiniLoader />
        </LoaderDiv>
      )}

      <GalleryModal
        open={openGallery}
        onClose={() => {
          setOpenGallery(false);
        }}
        width={"50%"}
        height={"50%"}
        images={images}
        index={clickedImage}
      />
      <ApproveModal
        open={openModalApprove.open}
        width={"30rem"}
        height={"30rem"}
        text={openModalApprove.text}
        title={openModalApprove.title}
        onClose={() => {
          setOpenModalApprove({
            open: false,
            text: "",
            title: "",
          });
        }}
      />
    </>
  );
};
export default MarketplaceOrderDetailsPage;
